import { z } from 'zod';
import { SchemaTimestamp } from '@axiom/types';

import { SavedCandidateFavoriteCandidateSchema } from './saved-candidate-favorite-candidate';

export const SavedCandidateSchema = z.object({
  candidate: SavedCandidateFavoriteCandidateSchema,
  candidateId: z.string().uuid(),
  createdAt: SchemaTimestamp.nullable(),
  id: z.string().uuid(),
  updatedAt: SchemaTimestamp.nullable(),
  userId: z.string().uuid(),
});

export type SavedCandidate = z.infer<typeof SavedCandidateSchema>;
